import { render, staticRenderFns } from "./FlowStepBase.vue?vue&type=template&id=4b007fa1&"
import script from "./FlowStepBase.vue?vue&type=script&lang=js&"
export * from "./FlowStepBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports